import { render } from "./AddEntitlement.vue?vue&type=template&id=da722d4c&scoped=true"
import script from "./AddEntitlement.vue?vue&type=script&lang=js"
export * from "./AddEntitlement.vue?vue&type=script&lang=js"

import "./add-entitlement.scss?vue&type=style&index=0&id=da722d4c&lang=scss&scoped=true"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da722d4c"]])

export default __exports__